import { Color } from '@billy/design-system'

import { InvoicePreviewRibbonVariant } from '../types/invoicePreviewRibbonVariant'

interface InvoicePreviewRibbonStyles {
  textColor: Color
  bgColor: Color
}

export const invoicePreviewRibbonVariantStyles: Record<InvoicePreviewRibbonVariant, InvoicePreviewRibbonStyles> = {
  black: {
    textColor: Color.White,
    bgColor: Color.Black,
  },
  grey: {
    textColor: Color.Grey950,
    bgColor: Color.Grey150,
  },
  lavender: {
    textColor: Color.White,
    bgColor: Color.Lavender500,
  },
}
